import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getIdentityMounts(companyId, identityId) {
	return dataTransferWrap(ModulesMap.IDENTITY_MOUNTS, dtConfig[ModulesMap.IDENTITY_MOUNTS].getIdentityMounts, {
		urlParams: {
			companyId,
			identityId,
		},
	})
}

function getBasedIdentityMounts(companyId, cashedPayload, identityId) {
	return dataTransferWrap(
		ModulesMap.IDENTITY_MOUNTS,
		dtConfig[ModulesMap.IDENTITY_MOUNTS].getBasedIdentityMounts,
		{
			urlParams: {
				companyId,
				identityId,
			},
		},
		cashedPayload
	)
}

function getExtendedIdentityMounts(companyId, cashedPayload, identityId) {
	return dataTransferWrap(
		ModulesMap.IDENTITY_MOUNTS,
		dtConfig[ModulesMap.IDENTITY_MOUNTS].getExtendedIdentityMounts,
		{
			urlParams: {
				companyId,
				identityId,
			},
		},
		cashedPayload
	)
}

function getFullIdentityMounts(companyId, cashedPayload, identityId) {
	return dataTransferWrap(
		ModulesMap.IDENTITY_MOUNTS,
		dtConfig[ModulesMap.IDENTITY_MOUNTS].getFullIdentityMounts,
		{
			urlParams: {
				companyId,
				identityId,
			},
		},
		cashedPayload
	)
}

function getIdentityMount(companyId, identityId, identityMountId) {
	return dataTransferWrap(ModulesMap.IDENTITY_MOUNTS, dtConfig[ModulesMap.IDENTITY_MOUNTS].getIdentityMount, {
		urlParams: {
			companyId,
			identityId,
			identityMountId,
		},
	})
}

function createIdentityMount(companyId, cardId, data) {
	return dataTransferWrap(ModulesMap.IDENTITY_MOUNTS, dtConfig[ModulesMap.IDENTITY_MOUNTS].createIdentityMount, {
		urlParams: {
			companyId,
			cardId,
		},
		...data,
	})
}

function patchIdentityMount(companyId, identityId, mountId, data) {
	return dataTransferWrap(ModulesMap.IDENTITY_MOUNTS, dtConfig[ModulesMap.IDENTITY_MOUNTS].patchIdentityMount, {
		urlParams: {
			companyId,
			identityId,
			mountId,
		},
		...data,
	})
}

function deleteIdentityMount(companyId, identityId, mountId) {
	return dataTransferWrap(ModulesMap.IDENTITY_MOUNTS, dtConfig[ModulesMap.IDENTITY_MOUNTS].deleteIdentityMount, {
		urlParams: {
			companyId,
			identityId,
			mountId,
		},
	})
}

export default {
	getIdentityMounts,
	getBasedIdentityMounts,
	getExtendedIdentityMounts,
	getFullIdentityMounts,
	getIdentityMount,
	createIdentityMount,
	patchIdentityMount,
	deleteIdentityMount,
}
